import DOMPurify from 'dompurify';

const STRIP_STYLE_PROPS = [
  /\s*letter-spacing\s*:[^;]+;?/g,
  /\s*font-weight\s*:\s*inherit\s*;?/g,
  /\s*font-size\s*:\s*inherit\s*;?/g,
  /\s*font-family\s*:\s*inherit\s*;?/g,
  /\s*line-height\s*:\s*inherit\s*;?/g,
];

export function sanitizedContent(content: string) {
  let clean = DOMPurify.sanitize(content);
  clean = clean.replace(/style="([^"]*)"/g, (_, styles: string) => {
    let result = styles;
    for (const pattern of STRIP_STYLE_PROPS) result = result.replace(pattern, '');
    result = result.trim();
    return result ? `style="${result}"` : '';
  });
  return clean;
}

export function isHTML(str: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}

export function removeHtmlTags(html: string) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
}
